import { useUser } from "@Light/components/auth/context";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useHeaderTitle } from "@Light/components/page/header/context";
import { MutationButton } from "@Light/components/page/MutationButton";
import { useScaffold } from "@Light/scaffold";
import { useAPI } from "@Light/services/api";
import { UpdateUser } from "@Light/services/apiTypes";
import { useLight } from "@Light/services/light";
import { useDispatch, useNavigate } from "@Light/utils/context";
import { useMutation } from "@Light/utils/mutation";
import React, { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";

const BACK_ROUTE = "/account/details/";

export type UpdateNameProps = {};

export const UpdateName: React.FC<UpdateNameProps> = ({}) => {
  const scaffold = useScaffold();
  const { useUpdateUserMutation } = useAPI();
  const user = useUser();
  const updateUser = useMutation<UpdateUser>(useUpdateUserMutation);
  const { register, handleSubmit, control } = useForm();
  const first_name = useWatch({ control, name: "first_name" });
  const last_name = useWatch({ control, name: "last_name" });
  const disabled =
    user.first_name === first_name && user.last_name === last_name;
  const light = useLight();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useHeaderTitle("Update your name");

  useEffect(() => {
    if (!updateUser.isSuccess) {
      return;
    }
    // Tell redux to invalidate our account data as the back end server should
    // have updated its value.
    dispatch(light.util.invalidateTags(["Account"]));
    navigate(BACK_ROUTE);
  }, [updateUser.isSuccess, light, dispatch, navigate]);

  const mutate = handleSubmit(({ first_name, last_name }: any) => {
    updateUser.mutate({ first_name, last_name });
  });

  const PageBody = scaffold.page.pageBody;
  const Field = scaffold.system.field;
  const Label = scaffold.system.label;
  const Input = scaffold.system.input;
  return (
    <form onSubmit={mutate}>
      <PageBody
        backLink={BACK_ROUTE}
        footerAfterContent={true}
        footer={
          <ButtonFooter>
            <MutationButton
              size="lg"
              mutate={mutate}
              mutation={updateUser}
              mutateButtonText="Confirm"
              errorMessage="Error updating your name. Please try again later."
              disabled={disabled}
            />
          </ButtonFooter>
        }
      >
        <div className="pt-8 flex flex-col gap-4">
          <Field>
            <Label>First name</Label>
            <Input
              {...register("first_name", {
                required: true,
                value: user.first_name,
              })}
            />
          </Field>
          <Field>
            <Label>Last name</Label>
            <Input
              {...register("last_name", {
                required: true,
                value: user.last_name,
              })}
            />
          </Field>
        </div>
      </PageBody>
    </form>
  );
};
